import styled from "@emotion/styled";
import { IconButton } from "@material-ui/core";
import { units } from "../../../../types/units";

export const Wrapper = styled(IconButton)`
  position: relative;
  display: block;
`;

export const ItemWrapper = styled.span`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0px;
  right: 0px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  ${units({
    color: "white",
    fontSize: "caption",
    fontWeight: "bold",
    backgroundColor: "orange",
  })};
`;
